export default __webpack_public_path__ + "static/media/0050.9005178d.jpg";